import Link from 'next/link'

import { type NonFsdsPuckPageProps,createNonFsdsPageGetServerSideProps } from '@/lib/create-non-fsds-page-gssp'
import { useBranding } from '@/hooks/use-branding'

import NonFsdsSignInPage from '@/components/auth/non-fsds-sign-in-page'
import { SignInForm } from '@/components/forms/auth/sign-in-form'
import { Icons } from '@/components/icons'
import NonFsdsEditablePageShell from '@/components/puck/non-fsds-editable-page-shell'
import SEO from '@/components/seo/SEO'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'

import { FORM_REGISTER_URL } from '@/constant/app'

export const getServerSideProps = createNonFsdsPageGetServerSideProps('sign-in')

function SignInPage({ puckData }: NonFsdsPuckPageProps) {
  const { isFsdsDomain } = useBranding()
  const isNonFsds = !isFsdsDomain

  if (isNonFsds) {
    return (
      <NonFsdsEditablePageShell
        slug="sign-in"
        seoTitle="Sign in"
        puckData={puckData}
        fallback={<NonFsdsSignInPage />}
      />
    )
  }

  return (
    <>
      <SEO title="Sign in" />
      <div className="container relative grid h-svh flex-col items-center justify-center lg:max-w-none lg:grid-cols-2 lg:px-0">
        <div className="relative hidden h-full flex-col bg-muted p-10 text-white dark:border-r lg:flex">
          <div className="absolute inset-0 bg-slate-100" />

          <div className="relative z-20 m-auto w-full">
            <blockquote className="space-y-2">
              <h2 className="mb-10 text-center text-4xl font-medium text-gray-800">
                &ldquo;At FSDS, we provide a comprehensive roadmap to becoming a Full Stack Data Scientist - mastering
                not just Machine Learning, but also Data Analytics, Data Engineering, and essential Domain Knowledge
                through a carefully crafted curriculum.&rdquo;
              </h2>
              <Avatar className="m-auto h-16 w-16">
                <AvatarImage src="/images/founder.jpg" className="pointer-events-none select-none object-cover" />
                <AvatarFallback>QD</AvatarFallback>
              </Avatar>
              <p className="text-center text-lg font-semibold text-gray-800">Quan Dang</p>
              <footer className="text-center text-base text-slate-400">Founder @ FSDS</footer>
            </blockquote>
          </div>
          <div className="relative z-20 mt-auto">
            <blockquote className="space-y-2 text-gray-400">
              <footer className="text-sm">&copy; {new Date().getFullYear()} FSDS from Robusto AI.</footer>
            </blockquote>
          </div>
        </div>
        <div className="lg:p-8">
          <div className="mx-auto flex w-full flex-col justify-center space-y-7 sm:w-[420px]">
            <div className="m-auto">
              <Link href="/">
                <Icons.logo className="mx-auto text-primary" />
              </Link>
            </div>
            <div className="space-y-2 text-center">
              <h1 className="text-2xl font-semibold tracking-tight">Sign In</h1>
              <p className="text-sm text-muted-foreground">Welcome back! Please enter your information.</p>
            </div>
            <div className="mt-6">
              <SignInForm disabledSignIn={false} />
            </div>
            <p className="px-8 text-center text-sm text-muted-foreground">
              Don&apos;t have an account?{' '}
              <Link href={FORM_REGISTER_URL} className="text-primary underline-offset-4 hover:underline">
                Get Advice Now
              </Link>{' '}
              or{' '}
              <Link href="/sign-up" className="text-primary underline-offset-4 hover:underline">
                Create a New Account
              </Link>
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default SignInPage
